import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type {
  ArabCountry,
  College,
  Governorate,
  Professsion,
} from "@/types/ProfileInfoTypes"

export const useArabCountriesData = () => {
  return useGenericQuery<ArabCountry[]>({
    keys: QUERY_KEYS.profileInfo.arabCountries(),
    apiEndpoint: ENDPOINTS.profileInfo.arabCountries(),
  })
}
export const useProfessionsData = () => {
  return useGenericQuery<Professsion[]>({
    keys: QUERY_KEYS.profileInfo.professions(),
    apiEndpoint: ENDPOINTS.profileInfo.professions(),
  })
}

export const useGovernoratesData = (id?: number) => {
  return useGenericQuery<Governorate[]>({
    keys: QUERY_KEYS.profileInfo.governorates(id!),
    apiEndpoint: ENDPOINTS.profileInfo.governorates(id!),
    enabled: !!id,
  })
}
export const useCollegesData = () => {
  return useGenericQuery<College[]>({
    keys: QUERY_KEYS.profileInfo.colleges(),
    apiEndpoint: ENDPOINTS.profileInfo.colleges(),
  })
}
